import './Wandschienenhoehe.scss';
import { useContext, useEffect, useState } from 'react';
import { validateWandschienenhoehe, ValidationMessage } from '../../utils/validations';
import AppContext, { AppData } from '../../AppContext';
import { getWandschienenhoehe } from '../../utils/app-data';
import applyDefaults from '../../utils/defaults';

function Wandschienenhoehe() {
  const { appData, setDynamicAppData } = useContext(AppContext);

  const [hoehe, setHoehe] = useState(getWandschienenhoehe(appData));
  const [validations, setValidations] = useState([] as ValidationMessage[]);

  const checkValidity = (data: AppData): boolean => {
    const checkedValidations = validateWandschienenhoehe(data);
    setValidations(checkedValidations);
    return !checkedValidations.find((v) => v.severity === 'error');
  };

  const inputColor = (error: boolean, warning: boolean) => {
    if (error) {
      return 'error';
    }
    if (warning) {
      return 'warning';
    }
    return 'valid';
  };

  const isError = () => !!validations.find((v) => v.severity === 'error'
    && v.kEigenschaft.includes(appData.static.kEigenschaftWandschienenhoehe));
  const isWarning = () => !!validations.find((v) => v.severity === 'warning'
    && v.kEigenschaft.includes(appData.static.kEigenschaftWandschienenhoehe));
  const inputColorValue = inputColor(isError(), isWarning());

  useEffect(() => {
    const newAppData = { ...appData };
    newAppData.dynamic.selectedVariationWerte[appData.static.kEigenschaftWandschienenhoehe] = hoehe;
    const valid = checkValidity(newAppData);

    setDynamicAppData((dynamicAppData) => {
      const newDynamicAppData = { ...dynamicAppData };
      newDynamicAppData.invalid = !valid;
      newDynamicAppData.selectedVariationWerte[appData.static.kEigenschaftWandschienenhoehe] = hoehe;
      return newDynamicAppData;
    });
  }, [hoehe, appData.dynamic.selectedVariationWerte[appData.static.kEigenschaftWandschienenhoehe]]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const calculatedDefaults = applyDefaults(appData, appData.static.kEigenschaftWandschienenhoehe);
    setHoehe(calculatedDefaults[appData.static.kEigenschaftWandschienenhoehe]);
  }, [appData.dynamic.selectedVariationWerte[appData.static.kEigenschaftStauhoehe]]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="configurator__wandschienenhoehe">
      <div className="inputs mt-3">
        <div className="input-group mb-2">
          <div className="input-group-prepend">
            <span className="input-group-text">Länge</span>
          </div>
          <input
            className={`${inputColorValue} form-control`}
            type="text"
            value={hoehe}
            placeholder="Wert"
            pattern="^[0-9]*$"
            onChange={(e) => {
              if (!Number.isNaN(Number(e.target.value))) {
                setHoehe(Number(e.target.value));
              }
            }}
          />
          <div className="input-group-append">
            <span className="input-group-text">mm</span>
          </div>
        </div>
      </div>
      <div>
        {validations.map((v) => v.messageContent)}
      </div>
    </div>
  );
}

export default Wandschienenhoehe;
